import { authFetch, authHeaders, resolveApiBaseUrl } from '../auth';
import { apiUrl } from './http';

export const utilityMethods = {
// Check if order exists in database
  async checkOrderExists(orderId) {
    try {
      const result = await this.makeAPICall(`/orders/${orderId}/`);
      return {
        exists: true,
        order: result
      };
    } catch (error) {
      return {
        exists: false,
        error: error.message
      };
    }
  },

  // Test database connection
  async testConnection() {
    try {
      const result = await this.makeAPICall('/health/');
      return {
        success: true,
        message: 'Database connection successful',
        data: result
      };
    } catch (error) {
      return {
        success: false,
        error: error.message
      };
    }
  }
};
